module.exports = __webpack_public_path__ + "static/media/LA.81912b8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LA.svg
// module id = 296
// module chunks = 0